/** ----------------------------------------
    Node Modules
 ---------------------------------------- */

import throttle from 'lodash/throttle';

/** ----------------------------------------
    Window
 ---------------------------------------- */

let windowData = {
    width: window.innerWidth,
    height: window.innerHeight,
    scrolledX: 0,
    scrolledY: 0
};

/** ----------------------------------------
    Events
 ---------------------------------------- */

export class MouseData {

    /** ----------------------------------------
        Constructor
     ---------------------------------------- */

    constructor() {
        this._mouse = null;
        this._window = null;
        this.watcher = {};
        this.events();
    }

    /** ----------------------------------------
        Mouse
     ---------------------------------------- */

    get data() {
        return this._mouse;
    }

    get window() {
        return this._window;
    }

    /** ----------------------------------------
        Resize Event
     ---------------------------------------- */

    resizeEvent() {
        window.addEventListener('resize', throttle(() => {
            windowData = {
                width: window.innerWidth,
                height: window.innerHeight
            };
        }, 250));
    }

    /** ----------------------------------------
         Scroll Event
     ---------------------------------------- */

    scrollEvent() {
        window.addEventListener('scroll', throttle(() => {
            windowData = {
                scrolledX: window.scrollX,
                scrolledY: window.scrollY
            };
        }));
    }

    /** ----------------------------------------
         Mouse Watcher
     ---------------------------------------- */

    mouseWachter() {
        console.log('changed');
    }

    /** ----------------------------------------
        Mouse Move
     ---------------------------------------- */

    mouseEvent() {
        let time = 0;
        let lastX = 0;
        let lastY = 0;
        let lastVx = 0;
        let lastVy = 0;
        let accX = 0;
        let accY = 0;
        let velX = 0;
        let velY = 0;

        let empty = false;
        let selected = '';
        let currentEl = document.body;
        let currentElType = '';

        window.addEventListener('mousemove', (e) => {
            if (time === 0) {
                time = Date.now();
                lastX = e.screenX;
                lastY = e.screenY;
                lastVx = velX;
                lastVy = velY;
                return;
            }

            const now = Date.now();
            const int = now - time;

            const dx = e.screenX - lastX;
            const dy = e.screenY - lastY;

            velX = Math.round(dx / int * 100) / 100;
            velY = Math.round(dy / int * 100) / 100;

            const ax = velX - lastVx;
            const ay = velY - lastVy;

            accX = Math.round(ax / int * 100) / 10;
            accY = Math.round(ay / int * 100) / 10;

            lastX = e.screenX;
            lastY = e.screenY;

            lastVx = velX;
            lastVy = velY;

            time = now;

            this._mouse = {
                x: e.clientX + windowData.scrolledX,
                y: e.clientY + windowData.scrolledY,
                vx: Math.abs(velX),
                vy: Math.abs(velY),
                ax: Math.abs(accX),
                ay: Math.abs(accY),
                hover: callback => {
                    const closest = e.target.closest('a');

                    if(e.target !== currentEl && (e.target.dataset.hover || closest && closest.dataset.hover) && empty) {
                        const type = e.target.dataset.hover || closest && closest.dataset.hover;
                        callback(true, type);
                        selected = type;
                        empty = false;
                    }

                    if((!e.target.dataset.hover || !closest.dataset.hover) && !empty && (closest === null || closest && closest.dataset.hover === null)) {
                        currentEl = e.target;
                        callback(false, 'empty');
                        selected = 'empty';
                        empty = true;
                    }
                }
            };
        });
    }

    mouseDefault() {
        this._mouse = {
            x: windowData.width / 2,
            y: windowData.height / 2,
            vx: 0,
            vy: 0,
            ax: 0,
            ay: 0,
            hover: () => null
        };
    }

    /** ----------------------------------------
        Events
     ---------------------------------------- */

    events() {
        this.resizeEvent();
        this.scrollEvent();
        this.mouseEvent();
        this.mouseDefault();
    }

}